import React from "react";
import { Reveal } from "./Reveal";
import { CtaButton } from "./CtaButton";
import { CountdownTimer } from "./CountdownTimer";
import { ScarcityBar } from "./ScarcityBar";
import { CheckIcon, GiftIcon, GlobeIcon } from "lucide-react";
const bonusList = ["Recetario Premium de Sales de Baño™", "Directorio de Proveedores™", "Calculadora de Costos y Precios™", "Pack de Etiquetas Editables™", "Guía Primeras Ventas™"];
const guarantees = ["Pago único", "Sin mensualidades", "Acceso de por vida", "Descarga inmediata"];
export function Offer() {
  return <section className="w-full bg-white px-5 py-14" data-id="element-130" data-mp="13wrgy47zjawd">
      <div className="mx-auto max-w-xl" data-id="element-131" data-mp="13yc8dkz06dq0">
        <Reveal className="text-center" data-id="element-132" data-mp="yy7orm2st2vk">
          <h2 className="font-serif-display text-2xl font-semibold text-[#3d2b30] sm:text-3xl" data-id="element-133" data-mp="yx4xve5h70fn">
            🎉 Todo lo que recibes hoy
          </h2>
        </Reveal>

        <Reveal delay={0.05} className="mt-8" data-id="element-134" data-mp="2admnauano2ss">
          <div className="rounded-3xl border-2 border-[#a04a63] bg-[#fbf5f0] p-6 shadow-xl shadow-[#a04a63]/10 sm:p-8" data-id="element-135" data-mp="2actpiitocnms">
            {/* Main product */}
            <div className="rounded-2xl bg-white p-5" data-id="element-136" data-mp="uiiprwfvsvro">
              <div className="flex items-start justify-between gap-3" data-id="element-137" data-mp="ulemxijwngf2">
                <div className="flex items-start gap-2" data-id="element-138" data-mp="ziwnakjuwnbg">
                  <CheckIcon className="mt-0.5 h-5 w-5 flex-shrink-0 text-[#a04a63]" data-id="element-139" data-mp="13jqepnwick93" />
                  <div data-id="element-140" data-mp="6tpsnwniwhvh">
                    <p className="font-serif-display text-base font-semibold text-[#3d2b30]" data-id="element-141" data-mp="6uioi2ky1myu">
                      Kit Lanza tu Línea de Sales de Baño™
                    </p>
                    <p className="mt-1 text-xs text-[#6b565b]" data-id="element-142" data-mp="funvwcq50ld0">
                      6 Tomos Digitales · +300 páginas · Sistema paso a paso · Acceso inmediato
                    </p>
                  </div>
                </div>
                <span className="whitespace-nowrap text-xs font-bold text-[#9a7d84] line-through" data-id="element-143" data-mp="3k7kp4njzhcjs">
                  $47 USD
                </span>
              </div>
            </div>

            {/* Bonuses */}
            <p className="mt-5 flex items-center gap-1.5 text-sm font-bold text-[#a04a63]" data-id="element-144" data-mp="vefs3yxu3yzi">
              <GiftIcon className="h-4 w-4" data-id="element-145" data-mp="qfmbhxn93rv4" /> Además, recibirás GRATIS:
            </p>
            <ul className="mt-3 space-y-2" data-id="element-146" data-mp="155to3wqkugnw">
              {bonusList.map(b => <li key={b} className="flex items-center justify-between gap-3 rounded-xl bg-white px-4 py-2.5" data-id="element-147" data-mp="105xjbva22l7a">
                  <span className="flex items-center gap-2 text-sm text-[#4d3a3f]" data-id="element-148" data-mp="cipq4bpwj2lm">
                    🎁 {b}
                  </span>
                  <span className="whitespace-nowrap text-xs font-bold text-[#9a7d84] line-through" data-id="element-149" data-mp="li2r0fzymiuq">
                    $17
                  </span>
                </li>)}
            </ul>

            {/* Value total */}
            <div className="mt-6 flex items-center justify-between rounded-2xl bg-[#3d2b30] px-5 py-4 text-white" data-id="element-150" data-mp="1wv54h26risao">
              <span className="text-sm font-bold uppercase tracking-wide" data-id="element-151" data-mp="1sx7g21ktga8c">Valor total</span>
              <span className="font-serif-display text-2xl font-bold line-through decoration-[#c98aa0] decoration-2" data-id="element-152" data-mp="20dcco91sk4v4">
                $132 USD
              </span>
            </div>

            <p className="mt-6 text-center text-sm leading-relaxed text-[#6b565b]" data-id="element-153" data-mp="1qhrg4qfhrwsr">
              ✨ Hoy no pagarás <span className="line-through" data-id="element-154" data-mp="1vgcawabz5o9t">$132 USD</span>. Ni siquiera
              pagarás <span className="line-through" data-id="element-155" data-mp="2j66jgfp9gqo9">$47 USD</span>. Porque queremos que cualquier
              persona que sueñe con lanzar su propia línea pueda comenzar hoy mismo.
            </p>

            {/* Price */}
            <div className="mt-6 text-center" data-id="element-156" data-mp="29ek88jcxarli">
              <p className="text-xs font-bold uppercase tracking-widest text-[#a04a63]" data-id="element-157" data-mp="2eeezio0m1j73">
                Hoy puedes empezar por solo
              </p>
              <p className="mt-1 font-serif-display text-5xl font-bold text-[#a04a63] sm:text-6xl" data-id="element-158" data-mp="322g5pqabgnjc">
                $12,99{" "}
                <span className="text-2xl" data-id="element-159" data-mp="36wkducvbj1m0">USD</span>
              </p>
              <p className="mt-2 flex items-center justify-center gap-1.5 text-xs font-semibold text-[#6b565b]" data-id="element-160" data-mp="1j7zb4i5bopys">
                <GlobeIcon className="h-3.5 w-3.5 text-[#a04a63]" data-id="element-161" data-mp="1e607d75o7r1b" />
                El cambio de moneda se realiza automáticamente en el checkout
              </p>
            </div>

            <ul className="mt-5 grid grid-cols-2 gap-2" data-id="element-162" data-mp="14af83grzl4v9">
              {guarantees.map(g => <li key={g} className="flex items-center gap-1.5 text-xs font-semibold text-[#4d3a3f]" data-id="element-163" data-mp="21vktu01196fc">
                  <CheckIcon className="h-4 w-4 text-[#a04a63]" data-id="element-164" data-mp="1wyb3mi5tkqqg" /> {g}
                </li>)}
            </ul>

            <div className="mt-6" data-id="element-165" data-mp="1s4zyclgnoi0n">
              <ScarcityBar data-id="element-166" data-mp="1n8j9tq5jo1n1" />
            </div>

            <div className="mt-6" data-id="element-167" data-mp="1n7pxm9ntgjxi">
              <CtaButton data-id="element-168" data-mp="2kn3sjuo0xybk">✨ Quiero lanzar mi línea hoy ✨</CtaButton>
            </div>

            <div className="mt-5" data-id="element-169" data-mp="2kp88xc340psq">
              <CountdownTimer data-id="element-170" data-mp="2fwf0oe8fmzbw" />
            </div>
          </div>
        </Reveal>
      </div>
    </section>;
}